import './global.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { FulfillerProvider } from './FulfillerContext';
import { SnackbarProvider } from './SnackbarContext';
import AppWithAuthWrapper from './AppWithAuthWrapper';
import { Provider } from 'react-redux';
import { store } from './store/store';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <FulfillerProvider>
      <SnackbarProvider>
        <Provider store={store}>
          <AppWithAuthWrapper />
        </Provider>
      </SnackbarProvider>
    </FulfillerProvider>
  </React.StrictMode>,
);
